import Attendance from './modules/Attendance';
import Build from './modules/Build';

export default {
  Attendance,
  Build,
};
